import { createSelector } from '@reduxjs/toolkit';

import { type ArenaOffersDto } from '@/common/types/shop/marketBoxes';

import { type RootState } from '../store';

const selectProfitDrops = (state: RootState): ArenaOffersDto[] | undefined => {
  return state.shop.profitDropOffers;
};

const selectAvailableProfitDrops = createSelector(
  selectProfitDrops,
  (offers): ArenaOffersDto[] => {
    return offers?.filter((offer) => !offer.isBuyingProcess) ?? [];
  },
);

export { selectAvailableProfitDrops };
